import React from "react";
import Slider from "react-slick";

export default function AboutService({ data, extraClass = "" }) {
  if (!data) return null;

  const settingskey = {
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 4000,
    infinite: true,
    arrows: false,
    dots: true,
    pauseOnHover: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },

      {
        breakpoint: 99999,
        settings: "unslick",
      },
    ],
  };

  return (
    <section className={`healthcare-facility ${extraClass}`}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-8">
            <div className="commitment-section">
              <p>The commitment driving Supershine today is built on the values that shaped our legacy. We deliver dependable commercial laundry solutions through reliable performance, industry expertise, advanced technology, and responsive service tailored to operational needs across diverse industries worldwide.</p>
            </div>
          </div>
        </div>
        {data?.items?.length > 0 && (
          <Slider {...settingskey} className="key-slides">
            {data.items.map((item, index) => (
              <div className="facility-slide" key={index}>
                <div className="facility-col">
                  {item?.icon && (<div className="icon">  <img src={item.icon} className="img-responsive" alt={item?.heading || "icon"} />  </div>)}
                  {item?.heading && (<div className="heading">  {item.heading}  </div>)}
                  {item?.description && (<p>{item.description}</p>)}
                </div>
              </div>
            ))}
          </Slider>
        )}
      </div>
    </section>
  )
}


